const mEditionBillingUsersMonitoring = {
  mEditionBillingUsersMonitoring: {
    alerts: {
      updateAcademiaActorEstado: {
        activationSuccess: 'El rol de usuario fue activado exitosamente.',
        deactivationSuccess: 'El rol de usuario fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    messages: {
      activeSince: 'Activo desde',
      lastLogin: 'Último login:',
      noContact: 'sin información de contacto',
      noData: 'No hay datos disponibles',
      mobile: 'Móvil',
      noLegal: 'sin información legal',
      noLocation: 'sin información de ubicación',
      noNumber: 'sin número',
      noTracking: 'sin registros',
      phone: 'Teléfono',
      wrongEmail: 'El email ingresado no pertenece a un usuario registrado'
    },

    labels: {
      // Academia related
      academyOwner: 'Propietario de la academia',
      academyUrl: 'Academia URL',
      storeUrl: 'Url Tienda',
      classroomUrl: 'Url Aula',
      relatedSales: 'Ver Ventas relacionadas',
      clickHere: 'click aquí',
      active: 'Activa',
      inactive: 'Inactiva',

      // License related
      licenses: 'LICENCIAS',
      license: 'Licencia',
      licenseCreatedDate: 'Licencia Fecha de Alta',
      academy: 'Academia',
      academyCreatedDate: 'Academia Fecha de Alta',
      academyDetails: 'Dellate Academia',
      sale: 'Venta',
      since: 'desde',
      saleDetails: 'Dellate Venta',
      saleIdForMigrations: 'Venta ID (para migraciones)',
      productDetails: 'Dellate Producto',

      // Resources
      resourcesUsed: 'RECURSOS USADOS',
      students: 'Alumnos',
      projects: 'Proyectos',
      learningMaps: 'Mapas de Aprendizaje',
      products: 'Productos',
      emailLists: 'Listas de e-mail',
      salesPoints: 'Puntos de venta',
      professionalUniversity: 'Universidad Profesional',
      integrations: 'Integraciones',
      unlimited: 'ilimitado',
      yes: 'Si',
      no: 'No',

      // Quick access
      quickAccess: 'ACCESOS RAPIDOS',
      productsByAcademy: 'Productos por Academia',
      projectsByAcademy: 'Proyectos por Academia',
      chargesByAcademy: 'Cobros por Academia',
      salesByAcademy: 'Ventas por Academia',
      clientsByAcademy: 'Clientes por Academia',

      // Droops (satelites)
      droops: 'DROOPS',
      droopAccount: 'Cuenta del Droop',
      droopGames: 'Juegos',
      droopQuestionsPerGame: 'Preguntas por juego',
      droopPlayersPerRoom: 'Jugadores por partida',
      droopIndividualMode: 'Modo individual',
      droopLiveMode: 'Modo en vivo',
      droopPlayersLive: 'jugadores por sala',
      droopEvaluations: 'Evaluaciones',
      droopQuestionsPerEvaluation: 'Preguntas por evaluación',
      droopRoulettes: 'Ruletas',
      droopSegmentsPerRoulette: 'Segmentos por ruleta',
      droopPrizesMode: 'Ruletas de premios',
      droopQuestionsMode: 'Ruletas de preguntas y retos',
      droopPublicLink: 'Enlace público',
      droopCsvExport: 'Exportación CSV',
      deleted: 'Eliminada',

      // No data messages
      noAcademyAssigned: 'No tiene academia asignada',
      noSaleAssigned: 'No proviene de una compra online'
    },

    // Inteligencia Artificial (licencias_ia): el plan mensual y cada paquete de créditos del usuario
    artificialIntelligence: {
      title: 'INTELIGENCIA ARTIFICIAL',
      modality: 'Modalidad',
      modalities: {
        mensual: 'Plan mensual',
        creditos: 'Paquete de créditos'
      },
      states: {
        activa: 'Activa',
        agotada: 'Agotada',
        suspendida: 'Suspendida',
        eliminada: 'Eliminada'
      },
      account: 'Cuenta de la compra',
      useCredits: 'Al agotarse el mes sigue con los paquetes de créditos',
      // Enlace al monitoreo interno de consumo de IA (item "Consumo de IA")
      usageRecord: 'Consumo, costo y detalle de lo que generó',

      credits: 'CRÉDITOS',
      creditsTotal: 'Créditos',
      // {creditos} llega ya formateado con separador de miles
      creditsBy: {
        mensual: '{creditos} por mes',
        creditos: '{creditos}, pago único'
      },
      available: 'Disponible',
      of: 'de',
      period: 'Mes del consumo',
      monthConsumption: 'Consumo del mes',
      accumulatedConsumption: 'Consumo acumulado desde la compra',
      apps: {
        juedroop: 'Juedroop',
        evaluaciones: 'Evaluaciones',
        academy: 'Academy',
        classroom: 'Classroom'
      },

      history: 'HISTÓRICO MES A MES',
      historyEmpty: 'Todavía no se cerró ningún mes.',
      historyColumns: {
        period: 'Mes',
        total: 'Total del mes',
        accumulated: 'Acumulado',
        credits: 'Créditos',
        current: 'Vigente al cierre'
      }
    },

    placeholders: {
      emailInput: 'Ingresa aquí el email del usuario'
    },

    title: 'ROLES DE USUARIO',
    titleAssets: 'ACADEMIAS'
  }
}

export default mEditionBillingUsersMonitoring
